import { Reducer } from "redux";

import { PriorAuthSubmitResponse } from "../models/api/Master";
import { PostPriorAuthSubmitDispatchTypes } from "../models/dispatchTypes/Referral";
import { PostPriorAuthSubmitActionDispatchTypes } from "../constants/Referral";

const initialState: PriorAuthSubmitResponse = {
  loading: false,
  response: {
  authorizationNumber: "",
  dateCompleted: "",
  memberName: "",
  referralId: 0,
  requestId: "",
  responseMessage: null,
  serviceRequestId: 0,
  status: "",
  userNameCreated: ""
  },
  error: null,
};

const PostPriorAuthReducer: Reducer<
  PriorAuthSubmitResponse,
  PostPriorAuthSubmitDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case PostPriorAuthSubmitActionDispatchTypes.POST_PRIOR_AUTH_SUBMIT_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case PostPriorAuthSubmitActionDispatchTypes.POST_PRIOR_AUTH_SUBMIT_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case PostPriorAuthSubmitActionDispatchTypes.POST_PRIOR_AUTH_SUBMIT_ERRORS: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case PostPriorAuthSubmitActionDispatchTypes.POST_PRIOR_AUTH_SUBMIT_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PostPriorAuthReducer;
